var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"fluid":""}},[_c('v-toolbar',{attrs:{"color":"transparent","flat":""}},[_c('v-toolbar-title',{staticClass:"grey--text text--darken-2"},[_c('v-subheader',[_vm._v(" Dashboard ")])],1),_c('v-spacer')],1),_c('v-row',[_c('v-col',[_c('Dashboard')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }